var React = require('react');

function HomepageThumbnailPath (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"homepage-thumbnail","fill":"none","stroke":"rgb(250,250,240)","strokeLinecap":"butt","strokeLinejoin":"miter","strokeWidth":"2","d":"M1539.2046301 155.03487522s-360.29471046-150.33024511-636.5-150.33024511c-276.20528952 0-450 108-513 272s71.5 468.5036218 241 453.25472868c169.5-15.24889311 159.5-199.05987496 0-157.84665033-159.5 41.21322463-59.54316245 271.51137876 155.5 493.32229881 451.5 465.7094383-781.5 342.48189667-781.5 342.48189667"}));
}

HomepageThumbnailPath.defaultProps = {"viewBox":"0 0 1543.909 1427.379"};

module.exports = HomepageThumbnailPath;

HomepageThumbnailPath.default = HomepageThumbnailPath;
